import { render, staticRenderFns } from "./ChildEdit.vue?vue&type=template&id=2202b116"
import script from "./ChildEdit.vue?vue&type=script&lang=js"
export * from "./ChildEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports